import InterfaceSoap from "../apiInterface/InterfaceSoap";
import { join, values, mapValues } from "lodash";
import ErrorAlert from "@/utility/ErrorAlert";

class DataSoap {
  async getDataSoapDokter(reg, idUser) {
    let dt: any;
    await InterfaceSoap.getSoapDokter(reg, idUser)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "SOAP Dokter");
      });
    return dt;
  }

  async getDataAllSoapDokter(reg) {
    let dt: any;
    await InterfaceSoap.getAllSoapDokter(reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "SOAP");
      });
    return dt;
  }

  async getDataSoapPerawat(reg, idUser) {
    let dt: any;
    await InterfaceSoap.getSoapPerawat(reg, idUser)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "SOAP Perawat");
      });
    return dt;
  }

  async getDataAllSoapPerawat(reg) {
    let dt: any;
    await InterfaceSoap.getAllSoapPerawat(reg)
      .then(response => {
        dt = response.data;
        // console.log('perawat', dt)
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "SOAP Perawat");
      });
    return dt;
  }

  async saveDataSoapDokter(reg, cm, userId, idUnit, s, o, a, p, ins, time) {
    let dt: object = {};
    await InterfaceSoap.saveSoapDokter(
      reg,
      cm,
      userId,
      idUnit,
      s,
      o,
      a,
      p,
      ins,
      time
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt;
  }

  async saveDataSoapPerawat(reg, cm, userId, idUnit, s, o, a, p, ins, time) {
    let dt: object = {};
    await InterfaceSoap.saveSoapPerawat(
      reg,
      cm,
      userId,
      idUnit,
      s,
      o,
      a,
      p,
      ins,
      time
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt;
  }

  async changeDataSoapDokter(s, o, a, p, ins, time, idSoap) {
    let dt: object = {};
    await InterfaceSoap.changeSoapDokter(s, o, a, p, ins, time, idSoap)
      .then(response => {
        dt = response.data;
        // console.log(dt)
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt;
  }

  async changeDataSoapPerawat(s, o, a, p, ins, time, idSoap) {
    let dt: object = {};
    await InterfaceSoap.changeSoapPerawat(s, o, a, p, ins, time, idSoap)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt;
  }
  async getDataAllSoap(reg) {
    let dt: any;
    await InterfaceSoap.getAllSoap(reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "SOAP");
      });
    return dt;
  }
  async deleteSoapPerawat(idSoap, alasan) {
    let dt: any;
    await InterfaceSoap.deleteSoapPerawat(idSoap, alasan)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Hapus SOAP Perawat");
      });
    return dt;
  }
  async deleteSoapDokter(idSoap, alasan) {
    let dt: any;
    await InterfaceSoap.deleteSoapDokter(idSoap, alasan)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Hapus SOAP Dokter");
      });
    return dt;
  }
}

export default new DataSoap();
